import { ROLES } from 'variables';
import { lazy } from 'react';

// project import
import Loadable from 'components/@ui/loader/Loadable';

// NEW
const Programs = Loadable(lazy(() => import('pages/humanitarian-organizations/prgoram-management/Programs')));
const Program = Loadable(lazy(() => import('pages/humanitarian-organizations/prgoram-management/program-details/ProgramDetailsPage')));

const Claims = Loadable(lazy(() => import('pages/humanitarian-organizations/claims-management/Claims')));

// BENEFICIARIES
const Beneficiaries = Loadable(
  lazy(() => import('pages/humanitarian-organizations/beneficiary-management/beneficiary-listing/BeneficiaryList'))
);
const ActivationCodes = Loadable(
  lazy(() => import('pages/humanitarian-organizations/beneficiary-management/activation-code-management/ActivationCodes'))
);
const ConsumerGroups = Loadable(
  lazy(() => import('pages/humanitarian-organizations/beneficiary-management/consumer-group-management/ConsumerGroupManagement'))
);

const Financials = Loadable(lazy(() => import('pages/humanitarian-organizations/financial-management/Financials')));

const ServiceCharges = Loadable(lazy(() => import('pages/humanitarian-organizations/service-charges-management/ServiceCharges')));

const RegionalOffices = Loadable(lazy(() => import('pages/humanitarian-organizations/regional-office-management/RegionalOffices')));

const HumanitarianDevelopment = Loadable(
  lazy(() => import('pages/humanitarian-organizations/humanitarian-development/HumanitarianDevelopment'))
);

//  Partners
const DistributionParterns = Loadable(
  lazy(() => import('pages/humanitarian-organizations/partner-management/distribution-partners/DistributionPartners'))
);
const FullfilmentParterns = Loadable(
  lazy(() => import('pages/humanitarian-organizations/partner-management/fullfilment-partners/FullfilmentPartners'))
);

// COLLECTION REGISTER
const Allocations = Loadable(lazy(() => import('pages/humanitarian-organizations/collection-register/alloctions-management/Allocations')));
const Disbursements = Loadable(
  lazy(() => import('pages/humanitarian-organizations/collection-register/disbursement-analystics/DisbursementAnalytics'))
);
const Transactions = Loadable(
  lazy(() => import('pages/humanitarian-organizations/collection-register/transactions-management/Transactions'))
);
// assets
import CampaignIcon from '@mui/icons-material/Campaign';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CalculateIcon from '@mui/icons-material/Calculate';
import ReceiptIcon from '@mui/icons-material/Receipt';
import GroupsIcon from '@mui/icons-material/Groups';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

// icons
const icons = {
  CampaignIcon,
  HandshakeOutlinedIcon,
  StorefrontIcon,
  CalculateIcon,
  ReceiptIcon,
  GroupsIcon,
  VolunteerActivismIcon,
  PaymentIcon,
  AccountBalanceWalletIcon
  // Add more icons as needed
};

//======================= VASEELAH ADMIN ROUTES ===================================//
export const humanitarianOrgRoutes = [
  {
    path: '/partners/fullfilment',
    element: <FullfilmentParterns />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: '/partners/distribution',
    element: <DistributionParterns />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'consumer-groups',
    element: <h1>Vaseelah Consumer Groups</h1>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'consumer-groups',
    element: <h1>Vaseelah Consumer Groups</h1>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'claims',
    element: <Claims />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  // BENEFICIARIES
  {
    path: 'beneficiaries',
    element: <Beneficiaries />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'beneficiaries/consumer-groups',
    element: <ConsumerGroups />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'beneficiaries/activation-codes',
    element: <ActivationCodes />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'agents',
    element: <h1>Vaseelah Agents</h1>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'partners',
    element: <h1>Vaseelah Partners</h1>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  // PROGRAMS
  {
    path: 'programs',
    element: <Programs />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'programs/:programId',
    element: <Program />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  // FINANTIAL PERFORMANCE
  {
    path: 'financial-performance',
    element: <Financials />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'service-charges',
    element: <ServiceCharges />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'region-offices',
    element: <RegionalOffices />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'collection-register',
    element: <h1>Vaseelah Collectio Register</h1>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'collection-register/transactions',
    element: <Transactions />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'collection-register/disbursement-analysis',
    element: <Disbursements />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'collection-register/allocations',
    element: <Allocations />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'humanitarian-development',
    element: <HumanitarianDevelopment />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'licen',
    element: <h1>Vaseelah Licen</h1>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  }
];

//=============================== VASEELAH ADMIN MENU ITEMS===============================//

export const humanitarianOrgMenuItems = [
  // {
  //   id: 'campaign-management',
  //   title: 'Campaigns',
  //   type: 'item',
  //   url: '/campaigns',
  //   icon: icons.CampaignIcon,
  //   breadcrumbs: true,
  //   feature_code: 'campaign-management'
  // },
  {
    id: 'partners',
    title: 'Partners',
    type: 'collapse',
    url: '/partners',
    icon: icons.HandshakeOutlinedIcon,
    breadcrumbs: true,
    feature_code: 'partner-management',
    children: [
      {
        id: 'fulfillment',
        title: 'Fulfillment',
        type: 'item',
        url: '/partners/fullfilment',
        breadcrumbs: true,
        feature_code: 'request-management'
      },
      {
        id: 'distribution',
        title: 'Distribution',
        type: 'item',
        url: '/partners/distribution',
        breadcrumbs: true,
        feature_code: 'request-management'
      }
    ]
  },

  {
    id: 'humanitarian-development',
    title: 'Humanitarian Development',
    type: 'item',
    url: '/humanitarian-development',
    icon: icons.GroupsIcon,
    breadcrumbs: true,
    feature_code: 'humanitarian-development'
  },
  {
    id: 'beneficiaries',
    title: 'Beneficiary Management',
    type: 'collapse',
    url: '/beneficiaries',
    icon: icons.VolunteerActivismIcon,
    breadcrumbs: true,
    feature_code: 'beneficiary-management',
    children: [
      {
        id: 'beneficiaries',
        title: 'Beneficiaries',
        type: 'item',
        url: '/beneficiaries',
        breadcrumbs: true,
        feature_code: 'beneficiary-management'
      },
      {
        id: 'consumer-groups',
        title: 'Consumer Groups',
        type: 'item',
        url: '/beneficiaries/consumer-groups',
        breadcrumbs: true,
        feature_code: 'beneficiary-management'
      },
      {
        id: 'activation-codes',
        title: 'Activation Codes',
        type: 'item',
        url: '/beneficiaries/activation-codes',
        breadcrumbs: true,
        feature_code: 'beneficiary-management'
      }
    ]
  },

  // {
  //   id: 'region-offices',
  //   title: 'Region Offices',
  //   type: 'item',
  //   url: '/region-offices',
  //   icon: icons.StorefrontIcon,
  //   breadcrumbs: true,
  //   feature_code: 'agent-management'
  // },
  {
    id: 'claims',
    title: 'Claims',
    type: 'item',
    url: '/claims',
    icon: icons.ReceiptIcon,
    breadcrumbs: true,
    feature_code: 'claim-management'
  },
  // {
  //   id: 'customers',
  //   title: 'Customers',
  //   type: 'item',
  //   url: '/customers',
  //   icon: icons.PeopleAltOutlinedIcon,
  //   breadcrumbs: true,
  //   feature_code: 'customer-management'
  // },
  {
    id: 'programs',
    title: 'Programs',
    type: 'item',
    url: '/programs',
    icon: icons.CampaignIcon,
    breadcrumbs: true,
    feature_code: 'programs'
  },
  {
    id: 'financial-performance',
    title: 'Financials',
    type: 'item',
    url: '/financial-performance',
    icon: icons.CalculateIcon,
    breadcrumbs: true,
    feature_code: 'financial-management'
  },
  {
    id: 'collection-register',
    title: 'Collection Register',
    type: 'collapse',
    url: '/collection-register',
    icon: icons.AccountBalanceWalletIcon,
    breadcrumbs: true,
    feature_code: 'collection-register',
    children: [
      {
        id: 'transactions',
        title: 'Transactions',
        type: 'item',
        url: '/collection-register/transactions',
        breadcrumbs: true,
        feature_code: 'collection-register'
      },
      {
        id: 'disbursement-analysis',
        title: 'Disbursement Analysis',
        type: 'item',
        url: '/collection-register/disbursement-analysis',
        breadcrumbs: true,
        feature_code: 'collection-register'
      },
      {
        id: 'allocations',
        title: 'Allocations',
        type: 'item',
        url: '/collection-register/allocations',
        breadcrumbs: true,
        feature_code: 'collection-register'
      }
    ]
  },
  {
    id: 'service-charges',
    title: 'Service Charges',
    type: 'item',
    url: '/service-charges',
    icon: icons.PaymentIcon,
    breadcrumbs: true,
    feature_code: 'service-charges'
  }
];
